import React, {useCallback, useRef} from 'react';
import Icon from '@bonprix/pattern-library/templates/icon';
import {addToClickedFilters, fillInitialClickedFilters} from '../../helper/filter-helper';
import {yieldToMain} from '../../ArticleOverviewHelper';

function Color({filterOptionChange, identifier, trackingId, filterOptions}) {

    const filterWrapper = useRef(null);
    const clickedFilters = useRef(fillInitialClickedFilters(filterOptions));

    const handleClick = useCallback((event, option) => {
        event.preventDefault();
        clickedFilters.current = addToClickedFilters(option.value, clickedFilters.current);
        yieldToMain(() => filterOptionChange(identifier, trackingId, clickedFilters.current));
    }, []);

    return (
        <div className="filter__color" ref={filterWrapper}>
            {filterOptions.map((option, index) => {
                return renderFilterOption(option, index);
            })}
        </div>
    );

    function renderFilterOption(option, index) {
        return (
            <div className="filter__option -color" key={index}>
                <input className="filter__color-input" type="checkbox"/>
                <label className="filter__color-input-label">{renderLinkElement(option)}</label>
            </div>
        );
    }

    function renderLinkElement(option) {
        const selected = clickedFilters.current.includes(option.value) ? 'is-selected' : '';
        const colorButtonClasses = `filter__color-button color color-${option.value} ${selected}`;

        return option.seoHref ? (
            <a className={colorButtonClasses} onClick={(event) => handleClick(event, option)} href={option.seoHref}>
                <Icon className="link__icon" name="checkbox-check"/>
            </a>
        ) : (
            <div className={colorButtonClasses} onClick={(event) => handleClick(event, option)}>
                <Icon className="link__icon" name="checkbox-check"/>
            </div>
        );
    }
}

export default React.memo(Color);
